import styled from "styled-components";
import colors from "../../../../../config/colors";
import { isMobile } from "../../../../../utils/common";

export const BrowserTableContainer = styled.div`
  overflow-y: scroll;
  max-height: calc(100vh - ${isMobile() ? 200 : 100}px);
  min-height: calc(100vh - ${isMobile() ? 200 : 100}px);
  height: calc(100vh - ${isMobile() ? 200 : 100}px);
  background-color:${colors.darkBackground};
  box-sizing:border-box;
  ${isMobile() && `font-size:2vw;`}
`;
export const TableRow = styled.div`
  background-color: ${colors.background};
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 2px 10px;
  padding: 5px 10px;
  border: solid 1px ${colors.darkBackground};
  box-sizing: border-box;
  transition: all 0.2s;
  :hover {
    cursor: pointer;
    border: solid 1px ${colors.primary};
    border-radius: 5px;
  }
`;
export const TableCell = styled.div`
  width: ${(props) => props.width}%;
`;

/**
 * When both options are back
  max-height: calc(100vh - ${isMobile() ? 164 : 183}px);
  min-height: calc(100vh - ${isMobile() ? 164 : 183}px);
  height: calc(100vh - ${isMobile() ? 164 : 183}px);
 */